module.exports = __webpack_public_path__ + "img/img10.ca93e48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/04/img10.png
// module id = 232
// module chunks = 0